/*
 *
 * RecordProcesses actions
 *
 */

import {
  GET_PROCESS_HISTORY_WATCHER,
  GET_PROCESS_HISTORY_SUCCESS,
  GET_PROCESS_HISTORY_FAILED
} from "./constants"


export function getProcessHistoryWatcher(payload) {
  return {
    type: GET_PROCESS_HISTORY_WATCHER,
    payload,
  }
}

export function getProcessHistorySuccess(payload) {
  return {
    type: GET_PROCESS_HISTORY_SUCCESS,
    payload,
  }
}

export function getProcessHistoryFailed(payload) {
  return {
    type: GET_PROCESS_HISTORY_FAILED,
    payload,
  }
}
